import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldCopyRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-copy',
	path: '/secure/admin/ViewCopyFieldScreen.jspa',
};
